<template>
  <div>
    <BaseDialog
      v-model="showDialog"
      dialogIcon="mdi-sync"
      title="Endre status"
      btnActionName="Lagre"
      scrollable
      @action="save"
      @close="close"
    >
      <template v-slot>
        <v-form ref="form" v-model="valid">
          <v-text-field
            :value="statusString"
            class="mb-5"
            prepend-inner-icon="mdi-sync"
            color="primary"
            label="Nåverende status"
            filled
            hide-details
            readonly
            disabled
          ></v-text-field>

          <v-select
            v-model="newStatus"
            :items="statusesComputed"
            prepend-inner-icon="mdi-sync"
            color="primary"
            label="Ny status"
            filled
            item-value="key"
            item-text="value"
            :rules="[(v) => v !== null || 'Ny status er ikke lagt til!']"
          ></v-select>

          <CommentInpute
            v-model="comment"
            :closeDialog="!showDialog"
            :desplayShowToCostomerBtn="true"
          />
        </v-form>
      </template>
    </BaseDialog>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import BaseDialog from "@/components/shared/dialog/BaseDialog.vue";
import CommentInpute from "@/components/shared/comments/CommentInpute.vue";

import { CommentObject } from "@/types/commentInterface";
import { KeyValueExtra } from "@/types/keyValue";
import notification from "@/helpers/notification";
export default Vue.extend({
  name: "EditProfileDialog",
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    statusId: {
      type: Number,
    },
    statusString: {
      type: String,
    },
    statuses: {
      type: Array as () => Array<KeyValueExtra>,
    },
  },
  data() {
    return {
      valid: false,
      newStatus: null,
      comment: {
        visibleToCustomer: false,
        status: 2,
        text: "",
        attachments: [] as any,
      } as CommentObject,
    };
  },
  methods: {
    save() {
      const isValid = (this as any).$refs?.form?.validate();

      if (isValid && this.comment?.newComment) {
        this.showDialog = false;
        this.$emit("save", {
          comment: this.comment,
          newStatus: this.newStatus,
        });
        (this as any).$refs.form.reset();
      } else if (!this.comment?.newComment) {
        notification.warn("Kommentar er ikke lagt til!");
      }
    },
    close() {
      (this as any).$refs.form.reset();
    },
  },

  computed: {
    showDialog: {
      get(): boolean {
        return this.value;
      },
      set(value: boolean) {
        this.$emit("input", value);
      },
    },
    statusesComputed(): Array<KeyValueExtra> {
      var data = this.statuses
        .filter((y) => y.key !== this.statusId)
        .map((x) => {
          // var test = { key: x.key }
          return {
            key: x.key,
            value: x.value,
            disabled: x.attr1 === "disabled",
          };
        });

      return data;
    },
  },

  components: {
    BaseDialog,
    CommentInpute,
  },
});
</script>
